<template>
    <v-card>
        <v-card-title>
            <span class="headline">{{ tipoOperacion }} monedero: {{ nombreCliente }}</span>
        </v-card-title>

        <v-card-text>
            <v-container grid-list-md>
                <v-row>
                    <v-col
                        xs="12"
                        sm="4"
                    >
                        <v-select
                            v-model="form.tipo_registro"
                            :items="selectTipoRegistro"
                            item-text="text"
                            item-value="id"
                            :error-messages="error_input.tipo_registro"
                            label="Tipo de operación"
                        />
                    </v-col>
                    <v-col
                        xs="12"
                        sm="4"
                    >
                        <v-select
                            v-model="form.modificar_saldo"
                            :items="[{ id: 'buy' , text : 'Saldo comprado'},{ id: 'reward', text: 'Saldo recompensa'}]"
                            item-text="text"
                            item-value="id"
                            :error-messages="error_input.modificar_saldo"
                            label="Saldo a modificar"
                        />
                    </v-col>
                    <v-col
                        xs="12"
                        sm="4"
                    >
                        <v-text-field
                            :value="form.monto"
                            :error-count="error_input.monto ? error_input.monto.length : 0"
                            :error-messages="error_input.monto"
                            type="number"
                            min="0"
                            step="0.01"
                            label="Monto"
                            @input="(payload) => form.monto = parseFloat(payload)"
                        />
                    </v-col>
                    <v-col
                        xs="12"
                    >
                        <v-textarea
                            v-model="form.comentarios"
                            :error-messages="error_input.comentarios"
                            label="Comentarios"
                            :placeholder="'Autorización: \nFecha:'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>

        <v-card-actions>
            <v-spacer/>
            <v-btn
                color="gray darken-1"
                @click="close"
            >
                Cancelar
            </v-btn>
            <v-btn
                color="blue darken-1"
                class="white--text"
                :loading="loading"
                :disabled="loading"
                @click="guardar"
            >
                Guardar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from 'axios';
    import {TIPO_REGISTRO_MONEDERO} from '@/constants.js';
    import EventBus from "../EventBus";

    export default {
        name: "FormSaldoMonedero",
        props: {
            nombreCliente: {
                type: String,
                default: ''
            },
            clienteId: {
                type: Number,
                default: 0
            },
            monederoId: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                form: {
                    user_id: this.$root.user.id,
                    cliente_id: this.clienteId,
                    monedero_id: this.monederoId,
                    monto: 1,
                    comentarios: '',
                    tipo_registro: 'add',
                    modificar_saldo: 'buy',
                },
                error_input: {},
                loading: false,
                TIPO_REGISTRO_MONEDERO
            }
        },
        computed: {
            selectTipoRegistro(){
                return TIPO_REGISTRO_MONEDERO.filter((item) => item.select)
            },
            tipoOperacion() {
                let operacion = this.TIPO_REGISTRO_MONEDERO.find((item) => item.id === this.form.tipo_registro);
                return operacion.text;
            },
        },
        watch: {
            item(val) {
                this.form = Object.assign({}, val);
            }
        },
        mounted() {

        },
        updated() {
        },
        methods: {
            close() {
                this.$emit('form:close', true);
            },
            guardar() {
                let url_target = '/api/clientes/monedero/operacion/'+this.monederoId;
                this.loading = true;

                this.error_input = Object.assign({});

                axios({
                    method: 'post',
                    url: url_target,
                    data: this.form
                })
                    .then((success) => {
                        let {data} = success;
                        this.loading = false;
                        if (data.success) {
                            EventBus.$emit('tugarrafon:show-snackbar', {
                                color: 'success',
                                text_content: success.data.message
                            });
                            this.form.nombre = '';
                            this.$emit('form:save', data.message);
                        }
                    })
                    .catch((error) => {
                        this.loading = false;

                        if (error.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            /*window.console.log(error.response.data);
                            window.console.log(error.response.status);
                            window.console.log(error.response.headers);
                            window.console.info("Es error");*/
                            if (error.response.status === 422) {
                                /*window.console.info("Es error");
                                window.console.log(error.response.data.data);*/
                                EventBus.$emit('tugarrafon:show-snackbar', {
                                    color: 'error',
                                    multi_line: true,
                                    text_content: error.response.data.message
                                });
                                this.error_input = Object.assign({}, error.response.data.data)
                            }

                            if (error.response.status === 400) {
                                /*window.console.info("Es error");
                                window.console.log(error.response.data.data);*/
                                EventBus.$emit('tugarrafon:show-snackbar', {
                                    color: 'error',
                                    multi_line: true,
                                    text_content: error.response.data.message
                                });
                                this.error_input = Object.assign({}, error.response.data.data)
                            }
                        } else if (error.request) {
                            // The request was made but no response was received
                            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                            // http.ClientRequest in node.js
                            /*window.console.log(error.request);*/
                        } else {
                            // Something happened in setting up the request that triggered an Error
                            /*window.console.log('Error', error.message);*/
                        }
                    })
            },
            loadTiposCupones() {
                this.loading_tipo_cupones = true;
                axios.get('/api/tipo-cupon', {params: {is_list: 1}})
                    .then((responseOk) => {
                        this.tipos_cupones = responseOk.data;
                    }).catch(() => {

                }).finally(() => {
                    this.loading_tipo_cupones = false;
                });
            },
        }
    }
</script>

<style scoped>

</style>
